{
  "name": "avocasino",
  "version": "1.0.11",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 0.0.0.0",
    "build": "ts-node ./setenv.ts --environment=prod && ng build --configuration=production",
    "build:dev-server": "ts-node ./setenv.ts --environment=prod && ng build --configuration devserver && npm run sentry:sourcemaps",
    "build:sourcemap": "ng build --source-map=true",
    "svg:generate": "gulp svg -f ./configs/gulp/gulp.js",
    "flags-svg-sprite:generate": "gulp flags-svg-sprite -f ./configs/gulp/gulp.js",
    "langs-svg-sprite:generate": "gulp langs-svg-sprite -f ./configs/gulp/gulp.js",
    "event-theme:styles": "gulp event-theme-styles -f ./configs/gulp/gulp.js",
    "lint-staged": "lint-staged",
    "eslint:fix": "eslint --fix --quiet",
    "eslint:all": "eslint src",
    "eslint:all:fix": "eslint src --fix",
    "stylelint:fix": "stylelint --formatter=verbose --fix",
    "stylelint:all": "stylelint --formatter=verbose \"src/**/*.scss\"",
    "stylelint:all:fix": "stylelint --formatter=verbose \"src/**/*.scss\" --fix",
    "commitlint": "commitlint --edit",
    "prepare": "husky install",
    "generate-sitemap": "ts-node --project=tsconfig.sitemap.json sitemap-generator.ts",
    "sourcemap": "ts-node ./setenv.ts --environment=prod && ng build --source-map=true && npx source-map-explorer dist/avocasino/main.*.js",
    "dev:ssr": "ng run avocasino:serve-ssr",
    "serve:ssr": "node dist/avocasino/server/server.mjs",
    "build:ssr": "ts-node ./setenv.ts --environment=prod && ng build --configuration=production",
    "prerender": "http-server -c-1 dist/avocasino",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org livesoft-71 --project avocasino --release $npm_package_name@$npm_package_version ./dist/avocasino && sentry-cli sourcemaps upload --org livesoft-71 --project avocasino --release $npm_package_name@$npm_package_version ./dist/avocasino"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.15",
    "@angular/common": "20.3.15",
    "@angular/compiler": "20.3.15",
    "@angular/core": "20.3.15",
    "@angular/forms": "20.3.15",
    "@angular/platform-browser": "20.3.15",
    "@angular/platform-browser-dynamic": "20.3.15",
    "@angular/platform-server": "20.3.15",
    "@angular/router": "20.3.15",
    "@angular/ssr": "^20.3.13",
    "@fingerprintjs/fingerprintjs": "^4.6.2",
    "@finteqhub/sdk-js": "^0.10.0",
    "@Front-end/seed": "7.3.9",
    "@Front-end/ui": "11.0.8",
    "@gilsdav/ngx-translate-router": "7.1.0",
    "@hotjar/browser": "^1.0.9",
    "@ngrx/component": "20.1.0",
    "@ngrx/effects": "20.1.0",
    "@ngrx/entity": "20.1.0",
    "@ngrx/router-store": "20.1.0",
    "@ngrx/store": "20.1.0",
    "@ngx-translate/core": "15.0.0",
    "@sentry/angular": "10.49.0",
    "@sentry/cli": "3.4.0",
    "date-fns": "2.30.0",
    "ngx-infinite-scroll": "^20.0.0",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.1",
    "socket.io-client": "2.4.0",
    "swiper": "^12.0.3",
    "tslib": "2.6.1",
    "zone.js": "0.15.1"
  },
  "stylelint": {
    "extends": [
      "@Front-end/stylelint-config"
    ]
  },
  "commitlint": {
    "extends": [
      "@Front-end/commitlint-config"
    ]
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --fix"
    ],
    "*.scss": [
      "stylelint --formatter=verbose --fix"
    ]
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "20.7.0",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "@angular-eslint/template-parser": "20.7.0",
    "@angular/build": "^20.3.13",
    "@angular/cdk": "20.2.14",
    "@angular/cli": "20.3.13",
    "@angular/compiler-cli": "20.3.15",
    "angular-eslint": "20.7.0",
    "@commitlint/cli": "18.4.4",
    "@commitlint/config-conventional": "18.4.4",
    "@Front-end/commitlint-config": "^1.0.0",
    "@Front-end/stylelint-config": "1.0.0",
    "@ngrx/store-devtools": "20.1.0",
    "@types/jasmine": "^4.3.5",
    "@types/jest": "27.4.1",
    "@types/node": "^18.19.7",
    "@types/qrcode": "^1.5.5",
    "@typescript-eslint/eslint-plugin": "8.56.0",
    "@typescript-eslint/parser": "8.56.0",
    "autoprefixer": "^10.4.20",
    "domhandler": "^5.0.2",
    "dotenv": "^16.3.1",
    "eslint": "9.39.3",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-rxjs-angular-x": "0.1.2",
    "eslint-plugin-rxjs-x": "0.9.5",
    "gulp": "^4.0.2",
    "gulp-clean-css": "^4.3.0",
    "gulp-postcss": "^10.0.0",
    "gulp-sass": "^5.1.0",
    "gulp-svg-sprite": "^2.0.1",
    "gulp-svgmin": "4.1.0",
    "http-server": "^14.0.0",
    "husky": "8.0.3",
    "hygen": "^6.2.11",
    "jasmine-core": "^5.1.0",
    "karma": "^6.4.2",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "13.2.3",
    "ngx-spec": "^2.1.6",
    "sass": "^1.79.4",
    "stylelint": "16.8.1",
    "ts-node": "^10.9.1",
    "typescript": "5.8.3",
    "typescript-eslint": "8.56.0"
  }
}
